import { createApi } from '@reduxjs/toolkit/query/react';
import { InvalidationTag, mlkWithRefreshAuth } from '../utils';
import {
  buildDeleteAddress,
  buildGeoInfo,
  buildGetAddresses,
  buildIsValidAddress,
  buildUpsertAddress,
} from './endpoints/addresses.endpoints';
import {
  buildConfirmEmail,
  buildFacebookSignIn,
  buildGoogleSignIn,
  buildRequestResetPassword,
  buildResendConfirmationCode,
  buildResetPassword,
  buildSignIn,
  buildSignUp,
} from './endpoints/auth.endpoints';
import {
  buildGetDriverLocation,
  buildGetOrder,
  buildGetOrders,
  buildGetPickUpPoints,
  buildGetServiceOptions,
  buildRequestSupport,
  buildUpdateOrder,
  buildUpsertReview,
} from './endpoints/orders.endpoints';
import {
  buildAddCart,
  buildAskRefund,
  buildCheckout,
  buildEditCartItem,
  buildGetCart,
  buildGetPurchase,
  buildGetPurchases,
  buildNotLoggedPurchaseFreeItem,
  buildPurchaseFreeItem,
  buildRemoveCartItem,
} from './endpoints/purchase.endpoints';
import {
  buildGetProfile,
  buildUpdatePassword,
  buildUpdateProfile,
} from './endpoints/user.endpoints';

export const mlkApi = createApi({
  reducerPath: 'mlkApi',
  baseQuery: mlkWithRefreshAuth,
  tagTypes: [
    InvalidationTag.Order,
    InvalidationTag.Addresses,
    InvalidationTag.User,
    InvalidationTag.Cart,
  ],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    // Orders
    getOrders: buildGetOrders(builder),
    getOrder: buildGetOrder(builder),
    getDriverLocation: buildGetDriverLocation(builder),
    getPickupPoints: buildGetPickUpPoints(builder),
    updateOrder: buildUpdateOrder(builder),
    upsertReview: buildUpsertReview(builder),
    getServiceOptions: buildGetServiceOptions(builder),
    sentRequestSupport: buildRequestSupport(builder),

    // Auth
    signIn: buildSignIn(builder),
    signUp: buildSignUp(builder),
    confirmEmail: buildConfirmEmail(builder),
    resendConfirmationCode: buildResendConfirmationCode(builder),
    googleSignIn: buildGoogleSignIn(builder),
    facebookSignIn: buildFacebookSignIn(builder),
    requestResetPassword: buildRequestResetPassword(builder),
    resetPassword: buildResetPassword(builder),

    // Profile
    updateProfile: buildUpdateProfile(builder),
    getProfile: buildGetProfile(builder),
    updatePassword: buildUpdatePassword(builder),

    // Addresses
    getAddresses: buildGetAddresses(builder),
    upsertAddress: buildUpsertAddress(builder),
    deleteAddress: buildDeleteAddress(builder),
    isValidAddress: buildIsValidAddress(builder),
    getGeoInfo: buildGeoInfo(builder),

    // Purchase
    checkout: buildCheckout(builder),
    addCart: buildAddCart(builder),
    editCartItem: buildEditCartItem(builder),
    purchaseFreeItem: buildPurchaseFreeItem(builder),
    purchaseNotLoggedFreeItem: buildNotLoggedPurchaseFreeItem(builder),
    getCart: buildGetCart(builder),
    deleteCartItem: buildRemoveCartItem(builder),
    getPurchases: buildGetPurchases(builder),
    getPurchase: buildGetPurchase(builder),
    askRefund: buildAskRefund(builder),
  }),
});
